export const alphaNumericSpecial = (value) => {
    var regex = /^[a-zA-Z0-9\-\.',&\/#+?\s]+$/;
    if (regex.test(value)) return true;
    return false;
};

export const validateAddress = (value) => {
    let data = value.replace(/[^a-zA-Z0-9\-\.\s,'&\/#+?]+/g, '');
    return data;
};

export const validatePostcode = (value) => {
    let data = value.replace(/[^A-Z\d\-\s_]+/g, '');
    return data;
};

export const allowOnlyNumber = (value) => {
    const re = /^[0-9\b]+$/;
    if (value === "" || re.test(value)) {
        return true;
    }
};

export const alphaNumeric = (value) => {
    var regex = /^[a-z\d\-_\s]+$/i;
    if (regex.test(value)) return true;
    return false;
};

export const sanitizeAddressInput = (value) => {
    return (
        value
            ?.replace(/[^A-Z0-9a-z ]/g, '')
            ?.replace(/^\s+/, '')
            ?.replace(/\s{1,}/g, ' ') || ''
    );
};

export const formatPostcode = (value) => {
    const cleaned = (value || '').replace(/[^A-Z0-9]/gi, '').toUpperCase().slice(0, 7);
    if (cleaned.length >= 5) {
        return cleaned.slice(0, cleaned.length - 3) + ' ' + cleaned.slice(cleaned.length - 3);
    }
    return cleaned;
};